import { useTranslation } from 'react-i18next'
import { KibSpinner } from '@chewy/kib-interstitials-react/legacy'
import KibTag from '@chewy/kib-tag-react'
import classNames from 'classnames'

import { MessageStatus } from '~/constants/communications'

import '@chewy/kib-interstitials-styles/dist/styles/kib-spinner.css'
import styles from './MessageStatusTag.module.scss'

const MessageStatusTag = ({
  status,
  isInternalNote,
}: {
  isInternalNote: boolean
  status: MessageStatus
}) => {
  const { t } = useTranslation()
  return (
    <>
      {!isInternalNote && status === MessageStatus.SENT && (
        <KibTag className={classNames(styles.messageStatus, styles.primary)}>
          <KibSpinner className={styles.sendingSpinner} />
          {t('Common:SENDING')}
        </KibTag>
      )}
      {status === MessageStatus.FAILED && (
        <KibTag className={styles.messageStatus} theme="error">
          {t('Communications:STATUS.CONVERSATION_DELIVERY_FAILED')}
        </KibTag>
      )}
      {status === MessageStatus.FORMING_FAILED && (
        <KibTag className={styles.messageStatus} theme="error">
          {t('Communications:MESSAGE_CARD.SEND_FAILED')}
        </KibTag>
      )}
      {status === MessageStatus.DRAFT && (
        <KibTag className={classNames(styles.messageStatus, styles.primary)}>
          {t('Common:DRAFT')}
        </KibTag>
      )}
    </>
  )
}

export default MessageStatusTag
